import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface LocalhostOnlyRouteProps {
    children: ReactNode;
}

const LOCALHOST_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);

/**
 * Renders its children only when the app is served from localhost; otherwise
 * redirects home. This hides internal/dev-only routes (e.g. the email metrics
 * dashboard) in deployed environments. Real enforcement lives on the backend,
 * whose outreach endpoints are guarded by `requireLocalhost` and 403 non-local
 * callers — this guard just avoids exposing the page at all off localhost.
 */
const LocalhostOnlyRoute = ({ children }: LocalhostOnlyRouteProps) => {
    const isLocalhost = LOCALHOST_HOSTNAMES.has(window.location.hostname);

    if (!isLocalhost) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default LocalhostOnlyRoute;
